// import { useApi, useMount } from "../hooks";

// export default function Logs(){
//     const {data:logs,load}= useApi<any>('http://localhost:4000/logs/kgss-1752579332-vstudio-knwvpuourg.json')
//     console.log(logs)
//     useMount(()=>{load()})
//     return <div>
//         {JSON.stringify(logs)}
//     </div>
// }


import { useMemo } from 'react';
import {
  Layout,
  Typography,
  Spin,
  Space,
  Row,
  Col,
  Card,
  Statistic,
  Table,
  Tag,
} from 'antd';
import { useApi, useMount } from '../hooks';
import { useSearch } from '@tanstack/react-router';
import { BASE_URL } from '../api';
import moment from 'moment';

const { Content } = Layout;
const { Text } = Typography;

export default function Logs() {
  const search = useSearch({ strict: false })
  const { data: log, load } = useApi<any>(`${BASE_URL}logs/${search['stream-key']}.json`)
  useMount(() => { load() })
  const grouped = useMemo(() => {
    if (!log) return {}
    //@ts-ignore
    return Object.groupBy(log?.entries, (item: any) => item.filePath)
  }, [log])

  //   useEffect(() => {
  //     fetch('/kgss-175257933.json')
  //       .then((res) => res.json())
  //       .then(setLog)
  //       .catch((err) => console.error('Failed to load log:', err));
  //   }, []);

  if (!log) {
    return (
      <Layout style={{ height: '100vh', padding: 24 }}>
        <Content style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Spin size="large" />
        </Content>
      </Layout>
    );
  }

  const summaryData = [
    {
      title: 'Successful',
      value: log.successful,
      color: '#44d044ff',
    },
    {
      title: 'Failed',
      value: log.failed,
      color: 'red',
    },
    {
      title: 'Total Files',
      value: log.totalFiles,
      color: 'black',
    },
    {
      title: 'Total Jobs',
      value: log.totalJobs,
      color: 'black',
    },
    {
      title: 'Started At',
      value: moment.utc(log.startedAt).utcOffset("+05:30").format("hh:mm:ss A"),
      color: '#0276fbd4',
    },
    {
      title: 'End At',
      value: moment.utc(log.finishedAt).utcOffset("+05:30").format("hh:mm:ss A"),
      color: '#0276fbd4',
    },
  ];

  const columns = [
    {
      title: '#',
      render: (_, __, index) => <Text>{index + 1}</Text>,
      width: 60,
    },
    {
      title: 'File Path',
      dataIndex: 'filePath',
      render: (text, item) => item
      // const record = grouped[item]
      // return record.map(it => {
      //   const isFailed = it.status === 'failed';
      //   const masterFile = it.filePath.includes('.m3u8')
      //   if (it.location) {
      //     return (
      //       <a
      //         href={it.location}
      //         target="_blank"
      //         rel="noopener noreferrer"
      //         style={{ color: isFailed ? 'red' : '#0ca111ff' }}
      //       >
      //         {it.filePath.split('/').splice(7).join('/')}
      //       </a>
      //     );
      //   } else {
      //     return (
      //       <Text type={isFailed ? 'danger' : 'secondary'}>{text}</Text>
      //     );
      //   }
      // })

    },
    // {
    //   title: 'Uploaded To',
    //   dataIndex: 'location',
    //   width: 60,
    //   render: (text, item) => {
    //     const record = grouped[item]
    //     return <>
    //       {record.map(it => it.location)}
    //     </>
    //   }
    // },

    {
      title: 'Failure Reason',
      dataIndex: 'reason',
      innerWidth: 50,
      render: (reason, item) => {
        return grouped[item].map(it => <Text type="danger">{(it.reason  ?? '  ---  ')} <br /></Text>)
      }
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (status, item) => {
        const record = grouped[item]
        const tagProps = {
          success: { color: 'green', text: 'Success' },
          failed: { color: 'red', text: 'Failed' },
          skip: { color: 'gray', text: 'Skipped' }
        };
        return <>
          {record.map(it => {
            console.log(tagProps[it.status])
            return <Tag color={tagProps[it.status]?.color}>{it.status}</Tag>
          })}
        </>;
      },
    },
    // {
    //   title: 'Uploaded At',
    //   dataIndex: '',
    //   render: (_, item) => {
    //     console.log({ _ })
    //     const record = grouped[item][0]
    //     return record.uploadedAt ? new Date(record.uploadedAt).toLocaleString() : "----"
    //   }
    // },
  ];

  return (
    <Card
      type="inner"
      title="Logs & Activities"
    >
      <Content>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Row gutter={[16,16]}>
            {summaryData.map((item, index) => (
              <Col xxl={6} xl={6} lg={8} md={8} sm={24} xs={24} key={index}>
                <Card>
                  <Statistic
                    title={<span style={{ color: item?.color }}>{item.title}</span>}
                    value={item.value}
                    valueStyle={{ fontSize: '24px', color: item?.color }}
                  />
                </Card>
              </Col>
            ))}
          </Row>

          <Table
            columns={columns}
            dataSource={Object.keys(grouped)}
            pagination={false}
            rowKey={(_, index) => index}
            size="middle"
            bordered
          />
        </Space>
      </Content>
    </Card>
  );
}